<template>
    <tile class="executory" link="executory">
        <tile-title icon="hand-o-up" slot="tileHeader">Исполнительные производства</tile-title>
        <div class="executory__content" slot="tileContent">
            <app-transition
                :showLeftIf="years.length > 0 && contentType === 'table'"
                :showRightIf="contentType === 'chart'"
            >
                <executory-table
                    v-if="stat" 
                    :years="sorted_years" 
                    :stat="stat"
                    slot="left"
                    ref="tableRef" 
                />
                <executory-chart 
                    v-if="contentType === 'chart'"
                    :years="sorted_years.slice().reverse()" 
                    :stat="stat"
                    slot="right" 
                />
            </app-transition>
            <executory-modal 
                v-if="isModal"
                :companyName="companyName"
                :title="title"
                :stat="stat" 
            />
        </div>
        <div class="executory__footer" slot="tileFooter">
            <app-switcher
                :leftClickHandler="changeType"
                :rightClickHandler="changeType"
            >
                <span slot="leftValue">Таблица</span>
                <span slot="rightValue">График</span>
            </app-switcher>
            <tile-print-pdf
                :html="htmlContent"
                :title="title"
                :printStyle="printStyle"
                filename="Executory"
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import appSwitcher from '@/components/ui/appSwitcher/appSwitcher.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import executoryTable from '@/components/card/executory/executoryTable.vue'
import executoryModal from '@/components/card/executory/executoryModal.vue'
import executoryChart from '@/components/card/executory/executoryChart.vue'
import appTransition from '@/components/ui/appTransition/appTransition.vue'

export default {
    components: {
        tile,
        appSwitcher,
        tileTitle,
        tilePrintPdf,
        executoryTable,
        executoryModal,
        executoryChart,
        appTransition
    },
    data: () => ({
        contentType: 'table',
        htmlContent: '',
        printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
            .executory-table { font-family: Helvetica, Arial, Tahoma, sans-serif; font-size: 14px; }
            .executory-table th { background: #ddddde; }
            .executory-table button { background: none; border: none; }
            .executory-table tfoot tr td { font-weight: 700; }
            .uk-icon-rub::before { content: '₽' !important; font-style: normal; font-weight: 700; }

        `
    }),
    computed: {
        sorted_years() {return this.years.slice().sort((a,b) => b - a)},
        stat() { return this.$store.state.card?.executory?.stat },
        isModal() { return this.$store.state.card?.executory?.isModal },
        years() { return this.$store.getters['card/executory/years'] },
        companyName() { return this.$store.state.card?.company?.name_short || this.$store.state.card?.company?.name_full },
        title() { return `Исполнительные производства | ${this.companyName}` }
    },
    methods: {
        changeType() { this.contentType = this.contentType === 'table' ? 'chart' : 'table' }
    },
    mounted() {
        this.$store.dispatch('card/executory/getStat')
            .finally(() => {
                if(this.years.length) {
                    $('#executory-label').html(
                        `<span class="uk-pseudolink" id="link-executory-tile">Найдено ${this.stat.total.opened.count_total + this.stat.total.closed.count_total} исполнительных производств</span>`
                    )
                    $('#link-executory-tile').on('click', () => { window.scrollToElement('executory-tile-link') })
                    this.htmlContent = this.$refs.tableRef?.$refs?.tileHtmlContent?.outerHTML
                    $('#sliders-item-executory').find('span').text(`Исполнительные производства ( ${this.stat.total.opened.count_total + this.stat.total.closed.count_total} )`)
                    $('#widemenu-item-executory').text(`Исполнительные производства ( ${this.stat.total.opened.count_total + this.stat.total.closed.count_total} )`)
                } else {
                    $('#executory-label').text('Исполнительные производства отсутствуют')
                    $('#executory-tile').hide()
                    $('#tiles').trigger('resize')
                }
            })
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.executory
    &__footer
        @include flex-between
</style>